/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { Fragment, useEffect, useContext } from 'react';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import _ from 'lodash';
// import Loader from 'modules/common/components/Loader';
import RPTBilling from './rpt/containers/RPTBilling';
import BTAXBilling from './btax/containers/BTAXBilling';
import RPTBillingSmartCity from './rpt/containers/RPTBillingSmartCity';
import RPTBillingSmartCityBorongan from './rpt/containers/RPTBillingSmartCityBorongan';
import BTAXBillingSmartCity from './btax/containers/BTAXBillingSmartCity';
import RPTBillingSettingsSmartCity from './settings/container/RPTBillingSettingsSmartCity';
import RPTApiNotice from './components/RPTApiNotice';
import BTAXApiNotice from './components/BTAXApiNotice';
import { checkCommonStringValue } from '../../helper'
import * as actions from './actions';
import * as c from './constants';

import CmsContext from '../../context/CmsContext';

function BillingsContainer({ match, settings, getSettings, permissions }) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const cmsLogo = _.get(CMS_LOGO, 'LOGO.cdnUrl');

  useEffect(() => {
    getSettings();
  }, []);

  // if (loadingSettings) {
  //   return <Loader customLogo={cmsLogo} />;
  // }

  const renderBillingModuleAndSource = (
    csvComponent,
    apiComponent,
    manualComponent,
    moduleType,
  ) => {
    const billingSettings = settings.list || [];
    if (
      billingSettings?.some(
        (item) =>
          _.get(item, 'attributes.source') === 'CSV' &&
          _.get(item, 'attributes.module_type') === moduleType
      )
    )
      return csvComponent;
    if (
      billingSettings?.some(
        (item) =>
          _.get(item, 'attributes.source') === 'MANUAL' &&
          _.get(item, 'attributes.module_type') === moduleType
      ) &&
      _.get(CMS_COMPONENTS, 'SMART_CITY_BILLING_SETTINGS_2')
    ) {
      return manualComponent;
    }

    // API
    return apiComponent;
  };

  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Billings</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/billing/rptax"
          >
            RPTAX
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/billing/btax"
          >
            BTAX
          </NavLink>
          {((settings.list || [])?.some(
            (item) =>
              _.get(item, 'attributes.source') === 'MANUAL' &&
              _.get(item, 'attributes.module_type') === "RPTAX"
            ) && _.get(CMS_COMPONENTS, 'SMART_CITY_BILLING_SETTINGS_2')
          ) && Acl(permissions, ['VIEW BILLINGS RPTAX SETTINGS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/billing/settings"
            >
              RPTAX Settings
            </NavLink>
          )}
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/rptax`} />}
          />
          <Route
            exact
            path={`${match.path}/rptax`}
            component={renderBillingModuleAndSource(RPTBilling, RPTApiNotice, (checkCommonStringValue("borongan", _.get(CMS_VARIABLES, "LGU_NAME")) ? RPTBillingSmartCityBorongan : RPTBillingSmartCity), 'RPTAX')}
          />
          <Route
            exact
            path={`${match.path}/btax`}
            component={renderBillingModuleAndSource(BTAXBilling, BTAXApiNotice, BTAXBillingSmartCity, 'BTAX')}
          />
          <Route
            exact
            path={`${match.path}/settings`}
            render={() => <RPTBillingSettingsSmartCity />}
          />
        </Switch>
      </div>
    </>
  );
}

BillingsContainer.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  settings: PropTypes.instanceOf(Object).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  // loadingSettings: PropTypes.bool.isRequired,
};
const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  settings: _.get(api, `${c.GET_SETTINGS}`) || {},
  // loadingSettings: _.get(api, 'loading', []).indexOf(c.GET_SETTINGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BillingsContainer);
